<span [innerHTML]="processedText"></span>
